import { useMutation } from "@apollo/client";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { CreateInboundDeliveryMutation } from "../../../graphql/deliveryService/mutations/createInboundDelivery";
import { handleError } from "../../../utils/graphqlHelper";

interface CreateInboundDeliveryMutationProps {
  dataAction: (id: string) => void;
  errorAction?: () => void;
}

const useCreateInboundDeliveryMutation = (
  props: CreateInboundDeliveryMutationProps,
) => {
  const { t } = useTranslation();
  const { dataAction, errorAction } = props;

  const mutation = useMutation(CreateInboundDeliveryMutation, {
    update: (cache) => {
      cache.evict({ fieldName: "inboundDeliveries" });
      cache.gc();
    },
  });

  const { data, error } = mutation[1];

  const inboundDeliveryCreated =
    data?.createInboundDelivery.inboundDeliveryDetail;

  useEffect(() => {
    if (!error) return;

    handleError(t("createInboundDeliveryError"), error.message, errorAction);
  }, [error]);

  useEffect(() => {
    if (!data) return;

    if (inboundDeliveryCreated) dataAction(inboundDeliveryCreated.id);
  }, [data]);

  return mutation;
};

export default useCreateInboundDeliveryMutation;
